import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
// import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";

import Shipping from "../components/Shipping";
import Contact from "../components/Contact";
import ScrollToTop from "react-scroll-to-top";

const ContactPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />


      {/* Breadcrumb */}
      <Breadcrumb title={"Contact"} />

      {/* Contact */}
      <Contact />

      {/* Shipping */}
      <Shipping />

      
    </>
  );
};

export default ContactPage;
